<template>
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    aria-hidden="true"
  >
    <path d="M16.56 7.56a1.5 1.5 0 0 0-2.12-2.12l-8 8a1.5 1.5 0 0 0 0 2.12l8 8a1.5 1.5 0 0 0 2.12-2.12L11.12 16H23.5a1.5 1.5 0 0 0 0-3H11.12l5.44-5.44Z" fill="currentColor" />
  </svg>
</template>
